import type QueryBuilder from '@/helpers/models/QueryBuilder'
import type { Model } from '@/helpers/models/Model'
export type FilterOp = 'is' | 'is_not'

function guidGenerator() {
	const S4 = function () {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
	}
	return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4()
}

export class Filter<FilterModel extends Model> {
	id: string = guidGenerator()
	key: string
	operator: FilterOp
	updateQuery?: (qb: QueryBuilder<FilterModel>) => QueryBuilder<FilterModel>

	constructor(params: {
		key: string
		operator?: FilterOp
		updateQuery?: (qb: QueryBuilder<FilterModel>) => QueryBuilder<FilterModel>
	}) {
		this.key = params.key
		this.operator = params.operator ?? 'is'
		this.updateQuery = params.updateQuery?.bind(this)
	}
}
